/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useState } from 'react';
import { Text, View } from 'react-native';
import { styles } from './styles';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';
import { SettingPersonalStore } from '../../stores/personal/setting-personal-store';
import { BfPageStoreProvider } from '@tw/tw-runtime-react';
import {
  TwAvatar,
  TwChip,
  TwColumn,
  TwFormItem,
  TwList,
  TwListItem,
  TwListItemContent,
  TwPage,
  TwPageHeader,
  TwRow,
  TwSection
} from '@tw/tw-components-rn';

export const SettingPersonal = () => {
  const [store] = useState(() => new SettingPersonalStore());
  usePageStoreLifecycle(store, undefined);
  return (
    <BfPageStoreProvider store={store}>
      <TwPage translucentStatusBar={true} style={styles.container}>
        <TwPageHeader title={'基本信息'} showBack={true} />

        {/* 内容区 */}
        <TwColumn space={3}>
          {/* 个人信息区域 */}
          <TwSection bodyStyle={styles.content}>
            {/* //TODO:图片动态化 */}
            <TwListItem
              title={'头像'}
              showArrow={true}
              rightContent={<TwAvatar></TwAvatar>}
              pressable={true}
            ></TwListItem>
            <TwListItem title={'ID'} rightContent={<Text>80564739</Text>}></TwListItem>
            {/* TODO:点击可修改 */}
            <TwListItem
              title={'昵称'}
              rightContent={<Text>ceuibcd</Text>}
              showArrow={true}
              pressable={true}
            ></TwListItem>
          </TwSection>

          {/* 手机号区域 */}
          <TwSection bodyStyle={styles.content}>
            <TwListItem title={'绑定手机号'} rightContent={<Text>13728374852</Text>} showArrow={true}></TwListItem>
          </TwSection>
          <TwSection bodyStyle={styles.content}>
            {/* TODO:可进入到地址页面 */}
            <TwListItem title={'收货地址'} showArrow={true} pressable={true}></TwListItem>
          </TwSection>
        </TwColumn>
      </TwPage>
    </BfPageStoreProvider>
  );
};
